import React, { useEffect, useState } from "react";
import decodeToken from "../../utils/decodeToken";
import CertifcateHtml from "../mentor/certifcateHtml";
import { Link } from "react-router-dom";

function Success() {
  const { email } = decodeToken();

  return (
    <div style={{ paddingTop: "10rem", paddingBottom: "3rem" }}>
      {/*className="container" Success Message Row */}
      <div className="row mb-4">
        <div className="col-12">
          <div className="card border-success">
            <div className="card-body text-center p-4">
              <i
                className="fa fa-check-circle mb-3"
                style={{ color: "#28a745", fontSize: 80 }}
              ></i>
              <h3 style={{ color: "#28a745", fontWeight: "bold" }}>
                Your payment is successful!
              </h3>
              <h5 className="text-muted mb-3">Thanks for your sponsorship!</h5>
              <p className="mb-3">
                We have sent an email to your email address <b>{email}</b>{" "}
                containing the details of your sponsorship. Please check your
                inbox.
              </p>
              <Link
                className="btn btn-primary"
                to="/sponsored-kids"
                style={{
                  backgroundColor: "#299D8E",
                  borderColor: "#299D8E",
                  padding: "10px 30px",
                  fontSize: "16px",
                }}
              >
                Go to Main Page
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Certificate Row */}
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body p-4 certificate-container">
              <CertifcateHtml />
            </div>
          </div>
        </div>
      </div>

      {/* Responsive Styles */}
      <style jsx>{`
        @media (max-width: 768px) {
          .container {
            padding: 0 15px;
            padding-top: 2rem !important;
            padding-bottom: 2rem !important;
          }

          .card {
            margin-bottom: 1rem;
          }

          .card-body {
            padding: 1rem !important;
          }

          .fa-check-circle {
            font-size: 60px !important;
          }

          h3 {
            font-size: 1.5rem !important;
            line-height: 1.3 !important;
          }

          h5 {
            font-size: 1.1rem !important;
          }

          p {
            font-size: 0.9rem !important;
            line-height: 1.4 !important;
          }

          .btn {
            padding: 8px 20px !important;
            font-size: 14px !important;
            width: 100%;
            max-width: 200px;
          }

          /* Certificate container responsive styles */
          .certificate-container {
            overflow-x: auto !important;
            padding: 1rem !important;
          }

          /* Certificate responsive styles */
          .receipt {
            width: 100% !important;
            min-width: 100% !important;
            max-width: 100% !important;
            min-height: auto !important;
            margin: 0 !important;
            border-radius: 8px !important;
            transform: scale(0.85) !important;
            transform-origin: top center !important;
          }

          .receipt-header {
            padding: 20px 15px !important;
          }

          .receipt-header img {
            height: 60px !important;
          }

          .receipt-header div {
            font-size: 12px !important;
          }

          .receipt-main {
            padding: 20px 15px !important;
          }

          .receipt-main h1 {
            font-size: 24px !important;
            margin-bottom: 20px !important;
          }

          .form-content {
            font-size: 14px !important;
          }

          .field {
            flex-direction: column !important;
            align-items: flex-start !important;
            margin-bottom: 10px !important;
          }

          .field span:first-child {
            min-width: auto !important;
            margin-bottom: 2px !important;
            font-size: 13px !important;
          }

          .field span:last-child {
            font-size: 13px !important;
          }

          .receipt-footer {
            padding: 15px !important;
          }

          .receipt-footer p {
            font-size: 12px !important;
          }

          /* Download button responsive */
          .d-flex.align-items-center.justify-content-between {
            flex-direction: column !important;
            gap: 10px !important;
            align-items: stretch !important;
          }

          .d-flex.align-items-center.justify-content-between h5 {
            text-align: center !important;
            margin-bottom: 0 !important;
          }

          .d-flex.align-items-center.justify-content-between button {
            width: 100% !important;
            max-width: none !important;
          }
        }

        @media (max-width: 480px) {
          .container {
            padding: 0 10px;
            padding-top: 1.5rem !important;
            padding-bottom: 1.5rem !important;
          }

          .card-body {
            padding: 0.75rem !important;
          }

          .certificate-container {
            padding: 0.5rem !important;
          }

          .receipt {
            transform: scale(0.75) !important;
            transform-origin: top center !important;
          }

          .fa-check-circle {
            font-size: 50px !important;
          }

          h3 {
            font-size: 1.3rem !important;
          }

          h5 {
            font-size: 1rem !important;
          }

          p {
            font-size: 0.85rem !important;
          }

          .receipt-header {
            padding: 15px 10px !important;
          }

          .receipt-header img {
            height: 50px !important;
          }

          .receipt-main {
            padding: 15px 10px !important;
          }

          .receipt-main h1 {
            font-size: 20px !important;
          }

          .form-content {
            font-size: 13px !important;
          }

          .field span:first-child {
            font-size: 12px !important;
          }

          .field span:last-child {
            font-size: 12px !important;
          }
        }
      `}</style>
    </div>
  );
}

export default Success;
